<template>
    <video-player
        class="player-video"
        :playsinline="true"
        :options="playOptions"
    />
</template>
<script>
export default {
    props: ['videoSrc', 'postSrc'],
    data() {
        return {
            playOptions: {},
        }
    },
    mounted() {
        this.playOptions = {
            height: '100%',
            width: '100%',
            playbackRates: [1.0], // 可选的播放速度
            autoplay: true, // 如果为true,浏览器准备好时开始回放
            muted: false, // 默认情况下静音播放
            loop: false, // 是否视频一结束就重新开始
            preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据，auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
            language: 'zh-CN',
            aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值，值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
            fluid: true, // 当true时，Video.js player将拥有流体大小，换句话说，它将按比例缩放以适应其容器
            sources: [
                {
                    type: 'video/mp4', // 类型
                    src:this.videoSrc , // url地址，在使用本地的资源时，需要用require()引入，否则控制台会报错
                },
            ],
            poster: this.postSrc, // 设置封面地址
            notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息
            controlBar: {
                currentTimeDisplay: true,
                progressControl: true, // 是否显示进度条
                playbackRateMenuButton: true, // 是否显示调整播放倍速按钮
                timeDivider: true, // 当前时间和持续时间的分隔符
                durationDisplay: true, // 显示持续时间
                remainingTimeDisplay: true, // 是否显示剩余时间功能
                fullscreenToggle: true, // 是否显示全屏按钮
            },
        }
    },
}
</script>
